var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

export { forceReflow };
